<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-user-tie"></i> Comissão
        </h2>
        <small class="text-muted"
          >Gerencie a comissão de seus vendedores.</small
        >
      </div>
    </div>
    <br />
    <b-card>
      <form @keyup.enter="select" @submit.prevent>
        <b-row>
          <b-col>
            <salesman-search v-model="searchForm.salesman_id" />
          </b-col>
          <b-col>
            <date-input v-model="searchForm.date_start" alias="Data Inicial" />
          </b-col>
          <b-col>
            <date-input v-model="searchForm.date_end" alias="Data Final" />
          </b-col>
          <b-col class="col-md-2 d-flex align-items-center"
            ><button
              type="button"
              class="mt-2 btn btn-sm btn-primary"
              @click="select($event)"
            >
              <i class="fas fa-search" /> Pesquisar
            </button></b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Calcular comissão por:">
              <b-form-radio v-model="searchForm.type" value="i"
                >Venda Realizada</b-form-radio
              >
              <b-form-radio v-model="searchForm.type" value="a"
                >Venda Recebida</b-form-radio
              >
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-card>

    <br />
    <b-row>
      <b-col md="8" class="pt-3 pr-0" cols="12">
        <commission-list
          @pagechange="select($event)"
          ref="CommissionList"
          :commissions="commissions"
        />
      </b-col>
      <b-col class="mt-5" md="4" cols="12">
        <b-card class="mb-2" v-for="row in commission_sum" :key="row.id">
          <b-card-title>
            <span class="fa-stack fa-1x">
              <i class="fas fa-circle fa-stack-2x text-success"></i>
              <i
                class="fas fa-dollar-sign fa-stack-1x fa-inverse text-white"
              ></i>
            </span>
            Total comissão
          </b-card-title>
          <b-card-text>
            <div class="d-flex justify-content-between">
              <span>
                {{ row.name }}
              </span>
              <b> R$:{{ row.sum_comission_value | decimal }} </b>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <error-handler :error="error" />
  </div>
</template>

<script>
import CommissionList from "./../../components/lists/CommissionList";
import SalesmanSearch from "@/components/SalesmanSearch";

export default {
  components: {
    CommissionList,
    SalesmanSearch,
  },

  data: function () {
    return {
      searchForm: {
        type: "i",
        name: null,
        date_start: null,
        date_end: null,
        salesman_id: null,
        page: null,
      },
      error: null,
      commission_sum: {},
      commissions: {},
    };
  },

  computed: {
    // commission() {
    // 	return this.$store.state.commission.commissions;
    // },
    // () {
    // 	return this.$store.state.commission.commission_sum;
    // }
  },

  mounted() {
    this.select();
    this.$store.commit("pageHasLoaded");
  },

  methods: {
    select(page = 1) {
      this.searchForm.page = page;
      this.$store.commit("showLoading");
      this.$store
        .dispatch("commission/getCommission", this.searchForm)
        .then((response) => {
          this.commission_sum = response.data.commission_sum;
          this.commissions = response.data.commissions;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },
  },
};
</script>
